module.exports = __webpack_public_path__ + "img/product_toothpaste_04.3ca86661.png";